export const borderColorChat = 'var(--QuickSilver)'
export const paddingChat = 2
export const noteColorChat = '#FEEDAE'
export const maxHeightChat = ({ md, insideReservation }: { md: boolean; insideReservation?: boolean }) => {
  return `calc(100vh - ${insideReservation ? '165px' : md ? '245px' : '115px'})`
}
